import { t } from 'i18next';
import { AnyAction, Dispatch } from 'redux';
import { checkTLS } from '../../../services/api/tlsCheck/tlsCheck';
import { loadingActions } from '../../../services/redux/features/loading.slice';

export const validateEmailTls = async (
  email: string,
  setFieldError: (field: string, message: string) => void,
  dispatch: Dispatch<AnyAction>
): Promise<boolean> => {
  try {
    dispatch(loadingActions.setLoading(true));

    const tlsValid = await checkTLS(email);

    if (!tlsValid) {
      setFieldError('email', t('validation:invalidEmailTls'));

      return false;
    }
    return true;
  } catch {
    return false;
  } finally {
    dispatch(loadingActions.setLoading(false));
  }
};
